import React from "react";
import "../../../css/DesignSystem/Buttons/OutlinedStatusButton.css";

export const OUTLINED_STATUS_BUTTON_COLORS = {
  yellow: {
    background: "var(--Yellow400)",
    text: "var(--Warning)",
    border: "var(--Warning)",
  },
  orange: {
    background: "var(--Orange400, #f8bcb1)",
    text: "var(--Orange, #c85040)",
    border: "var(--Orange, #c85040)",
  },
  brandingOrange: {
    background: "var(--BrandingOrange400)",
    text: "var(--BrandingOrange)",
    border: "var(--BrandingOrange)",
  },
  orange600: {
    background: "var(--Orange100, #fff4e5)",
    text: "var(--Orange600, #e66a00)",
    border: "var(--Orange600, #e66a00)",
  },
  blue: {
    background: "var(--Blue400)",
    text: "var(--Brand1-PenBlue)",
    border: "var(--Brand1-PenBlue)",
  },
  green: {
    background: "var(--Green400)",
    text: "var(--Success)",
    border: "var(--Success)",
  },
  red: {
    background: "var(--Red400)",
    text: "var(--Error)",
    border: "var(--Error)",
  },
  grey: {
    background: "var(--Grey200, #f2f4f7)",
    text: "var(--Grey700, #344054)",
    border: "var(--Grey400, #d0d5dd)",
  },
  crimson: {
    background: "var(--Crimson400, #e3fafa)",
    text: "var(--Crimson, #20B2AA)",
    border: "var(--Crimson, #20B2AA)",
  },
  purple: {
    background: "var(--Purple400, #f3e8ff)",
    text: "var(--Purple, #9b51e0)",
    border: "var(--Purple, #9b51e0)",
  },
};

const OutlinedStatusButton = ({
  label,
  color = "grey",
  onClick,
  className = "",
  disabled = false,
  type = "button",
}) => {
  const selectedColor =
    typeof color === "string"
      ? OUTLINED_STATUS_BUTTON_COLORS[color] || OUTLINED_STATUS_BUTTON_COLORS.grey
      : color;

  const styles = {
    "--outlined-status-button-bg": selectedColor.background,
    "--outlined-status-button-text": selectedColor.text,
    "--outlined-status-button-border": selectedColor.border,
  };

  const Element = onClick ? "button" : "span";

  return (
    <Element
      type={onClick ? type : undefined}
      className={`outlined-status-button FP_Content_Semibold uppercase no-text-wrap ${className}`}
      style={styles}
      onClick={onClick}
      disabled={onClick ? disabled : undefined}
    >
      {label}
    </Element>
  );
};

export default OutlinedStatusButton;
